import { Logger } from "../utils/logger";
import { FormWidget } from "../components/formWidget";
import { PageBuilderContactFormPropertiesModel } from "@de-trustleap/shared-models";
import { Spinner } from "../helpers/spinner";

/**
 * Baut ein vollständiges, dynamisches Formular für die statische Default Landingpage
 * mit allen Validierungen, Honeypot, Consent-Checkboxen usw.
 */
export async function injectFormIntoDefaultPage(): Promise<void> {
    Logger.info("📝 Baue dynamisches Formular für Default LandingPage...");

    // 🟢 Spinner-Instanz vorab initialisieren, falls noch nicht vorhanden
    Spinner.getInstance("loading-spinner");

    const targetContainer = document.getElementById("contact-form");

    if (!targetContainer) {
        Logger.warn("❌ Kein Element mit ID #contact-form gefunden – Formular wird nicht eingefügt.");
        return;
    }

    // 🟢 Optional: Sicherstellen, dass spinner.css geladen ist (nur falls du dynamisch CSS lädst)
    // Alternativ kannst du diese Zeile weglassen, wenn du spinner.css eh global hast
    // const link = document.createElement('link');
    // link.rel = 'stylesheet';
    // link.href = '/styles/spinner.css';
    // document.head.appendChild(link);

    // Fallback-Properties für die Default-Seite
    const defaultFormProperties = new PageBuilderContactFormPropertiesModel({
        nameTextFieldProperties: {
            placeholder: "Ihr Name",
            isRequired: true,
        },
        emailTextFieldProperties: {
            placeholder: "Ihre E-Mail",
            isRequired: true,
        },
        phoneTextFieldProperties: {
            placeholder: "Ihre Telefonnummer",
            isRequired: true,
        },
        messageTextFieldProperties: {
            placeholder: "Ihre Nachricht",
            isRequired: true,
        },
        buttonProperties: {
            text: "Jetzt Kontakt aufnehmen",
        },
        checkboxProperties: {
            labelText: "Ich akzeptiere die Datenschutzbestimmungen.",
            isRequired: true,
            linkText: "Datenschutz lesen",
            linkUrl: "/legalpages/datenschutz.html",
        },
        initialInfo: {
            labelText: "Ich habe die Erstinformation gelesen.",
            isRequired: true,
            linkText: "Mehr erfahren",
            linkUrl: "/legalpages/erstinformation.html",
        }
    });

    try {
        const formWidget = new FormWidget(defaultFormProperties, true);
        const formElement = await formWidget.createForm();

        targetContainer.innerHTML = "";
        targetContainer.appendChild(formElement);

        Logger.info("✅ Dynamisches Formular erfolgreich in Default-Seite eingefügt.");
    } catch (error) {
        Logger.error("❌ Fehler beim Erzeugen des dynamischen Formulars für Default LandingPage", error);
    }
}
